import { BREAKPOINTS } from '../../utils/breakpoints';
import type { CarouselBreakpoint } from './types';
/**
 * Multi-card default breakpoint configuration
 * 480~: 1 card, 768~: 2 cards, 1440~: 3 cards
 */
export const MULTI_CARD_DEFAULT_BREAKPOINTS: CarouselBreakpoint[] = [
  { width: 0, visibleCards: 1 },
  { width: BREAKPOINTS.XS, visibleCards: 2 },
  { width: BREAKPOINTS.LARGE, visibleCards: 3 },
];

/**
 * Multi-card peek breakpoint configuration
 * 480~: 1 card, 768~: 2 cards, 960~: 2+peek, 1280~: 3+peek, 1440~: 3 cards
 */
export const MULTI_CARD_PEEK_BREAKPOINTS: CarouselBreakpoint[] = [
  { width: 0, visibleCards: 1, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.SMALL, visibleCards: 2, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.MEDIUM, visibleCards: 2, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.LARGE, visibleCards: 3, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.XLARGE, visibleCards: 3, showPeek: false },
];

export const MULTI_CARD_PEEK_ALL_BREAKPOINTS: CarouselBreakpoint[] = [
  { width: 0, visibleCards: 1, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.SMALL, visibleCards: 2, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.MEDIUM, visibleCards: 3, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.LARGE, visibleCards: 3, showPeek: true, peekAmount: 10 },
  { width: BREAKPOINTS.XLARGE, visibleCards: 3, showPeek: true, peekAmount: 10 },
];

/**
 * Spotlight breakpoint configuration: Single focus
 * 480~: 1 card for all viewports
 */
export const SPOTLIGHT_BREAKPOINTS: CarouselBreakpoint[] = [
  { width: 0, visibleCards: 1, showPeek: false },
];

/**
 * Spotlight breakpoint configuration: Single focus
 * 480~: 1 card, 768~: 1 card with contextual peeking
 */
export const SPOTLIGHT_PEEK_BREAKPOINTS: CarouselBreakpoint[] = [
  { width: 0, visibleCards: 1, showPeek: false },
  { width: BREAKPOINTS.XS, visibleCards: 1, showPeek: true, peekAmount: 3.5 },
];

/**
 * Timeline breakpoint configuration: Auto-advance timeline
 * 480~: 1+partial, 768~: 2 cards, 960~: 2+partial, 1280~: 3 cards
 */
export const TIMELINE_BREAKPOINTS: CarouselBreakpoint[] = [
  { width: 0, visibleCards: 1, showPeek: true, peekAmount: 30 },
  { width: BREAKPOINTS.XS, visibleCards: 2, showPeek: false },
  { width: BREAKPOINTS.SMALL, visibleCards: 2, showPeek: true, peekAmount: 30 },
  { width: BREAKPOINTS.LARGE, visibleCards: 3, showPeek: false },
];
